import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20Chinese%20literary%20aesthetic%20background%2C%20warm%20golden%20and%20cream%20abstract%20texture%2C%20soft%20flowing%20ink%20wash%20painting%20style%2C%20subtle%20book%20pages%20flying%20artistically%2C%20warm%20ambient%20glow%2C%20sophisticated%20and%20romantic%20atmosphere%2C%20literary%20magazine%20cover%20quality%2C%20dreamy%20and%20ethereal%20mood%2C%20high%20resolution%20fine%20art&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="好色小姨故事集背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
          好色小姨
        </h1>
        <p className="text-lg md:text-xl text-white/90 mb-4 leading-relaxed max-w-2xl mx-auto">
          都市情感故事精选合集
        </p>
        <p className="text-sm md:text-base text-white/70 mb-8 leading-relaxed max-w-xl mx-auto">
          深度解读都市言情小说中备受关注的经典角色类型，探索这一充满戏剧张力的人物设定及其背后的情感逻辑
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/renwu-fenxi"
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            探索人物分析
          </Link>
          <Link
            to="/category/gushi-heji"
            className="px-8 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
          >
            浏览故事合集
          </Link>
        </div>
      </div>
    </section>
  );
}